export type ForecastData = {
  year: string;
  revenue?: number;
  netResult?: number;
  ebitda?: number;
  grossMargin?: number;
};

/**
 * Parse a [@shaarp/forecast ...] tag from AI stream text
 */
export function parseForecast(text: string): ForecastData | null {
  const match = text.match(/\[@shaarp\/forecast\s+([^\]]+)\]/);
  if (!match) return null;

  const attrs = match[1];

  const getNumber = (key: string): number | undefined => {
    const m = attrs.match(new RegExp(`${key}=(-?\\d+)`));
    return m ? parseInt(m[1], 10) : undefined;
  };

  const yearMatch = attrs.match(/year=(\d{4})/);
  if (!yearMatch) return null;

  const data: ForecastData = { year: yearMatch[1] };

  const revenue = getNumber("revenue");
  const netResult = getNumber("netResult");
  const ebitda = getNumber("ebitda");
  const grossMargin = getNumber("grossMargin");

  if (revenue != null) data.revenue = revenue;
  if (netResult != null) data.netResult = netResult;
  if (ebitda != null) data.ebitda = ebitda;
  if (grossMargin != null) data.grossMargin = grossMargin;

  return data;
}
